import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// appsetup - Get All (Read)
export const GetAllWithdrawlRequest = createAsyncThunk(
  "/admin/withdrawl-request",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.WithdrawlRequest.withdrawlRequest}?name=${
          filter?.name || ""
        }&from=${filter?.from || ""}&to=${filter?.to || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Get (Read)
export const GetAppSetUp = createAsyncThunk(
  "admin/fund-request/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.FundRequest}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Create (Add)
export const AddAppSetUp = createAsyncThunk(
  "admin/fund-request/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.FundRequest, data);
      return res; // The new AppSetUp object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Delete
export const DeleteAppSetUp = createAsyncThunk(
  "admin/fund-request/delete",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.FundRequest}/${id}`);
      return id; // Return the id of the deleted AppSetUp
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Status
export const StatusUpdate = createAsyncThunk(
  "admin/withdrawl-request/status",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.WithdrawlRequest.withdrawlRequest}/status/${id}`,
        {
          status: data,
        }
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "fund-request",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetAppSetUp, AddAppSetUp, UpdateAppSetUp, DeleteAppSetUp
      .addCase(GetAllWithdrawlRequest.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllWithdrawlRequest.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllWithdrawlRequest.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (appsetup) => appsetup.id !== action.payload.id
        ); // Remove the AppSetUp with the deleted id
      })
      .addCase(DeleteAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusUpdate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusUpdate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (appsetup) => appsetup.id !== action.payload.id
        ); // Remove the appsetup with the deleted id
      })
      .addCase(StatusUpdate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
